import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ClearIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#b3aa6a' : this.getColor()

        return [
            <g transform="translate(-410.975 -454.575)">
                <g>
                    <path d="M422.9,456.6a7,7,0,1,0,0,9.9A6.971,6.971,0,0,0,422.9,456.6Zm-2.1,6.4a.99.99,0,0,1-1.4,1.4L418,463l-1.4,1.4a.99.99,0,0,1-1.4-1.4l1.4-1.4-1.4-1.4a.99.99,0,0,1,1.4-1.4l1.4,1.4,1.4-1.4a.99.99,0,0,1,1.4,1.4l-1.4,1.4Z" fill={color} fillRule="evenodd"/>
                </g>
            </g>
        ]
    }
    getViewBox = () => '0 0 13.988 13.95'
}
